import { render } from "./RiDeco1.vue?vue&type=template&id=31b5d7a7"
import script from "./RiDeco1.vue?vue&type=script&lang=js"
export * from "./RiDeco1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiDeco1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31b5d7a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31b5d7a7', __exports__)) {
    api.reload('31b5d7a7', __exports__)
  }
  
  module.hot.accept("./RiDeco1.vue?vue&type=template&id=31b5d7a7", () => {
    api.rerender('31b5d7a7', render)
  })

}


export default __exports__